import { ChevronDown, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { trackPhoneClick } from "@/lib/gtag";
import officeBg from "@/assets/office-bg.webp";

const HeroSection = () => {
  const { t } = useLanguage();

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={officeBg}
          alt="Professional law office with city skyline view"
          className="w-full h-full object-cover object-center"
          fetchPriority="high"
          decoding="async"
        />
      </div>
      
      {/* Darker overlay for text contrast */}
      <div className="absolute inset-0 bg-navy/80" />

      {/* Content */}
      <div className="relative z-10 container-custom flex items-center justify-center min-h-screen py-24">
        <div className="flex flex-col items-center justify-center text-center max-w-4xl mx-auto">
          {/* Trust Badge */}
          <div
            className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-gold/30 bg-white/5 backdrop-blur-sm mb-8"
          >
            <span className="text-gold text-sm font-medium tracking-wide">
              {t("hero.trustBadge")}
            </span>
          </div>

          {/* H1 + Subtitle */}
          <div className="flex flex-col items-center justify-center gap-2 text-center mb-6">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
              <span className="block mb-2">{t("hero.h1.line1")}</span>
              <span className="block">{t("hero.h1.line2")}</span>
            </h1>
            <p className="text-2xl md:text-3xl mt-2 md:mt-4 text-white font-medium">
              <span className="text-gold-gradient">{t("hero.h1.line3.locations")}</span>
            </p>
          </div>

          {/* H2 - Emotional Subheadline */}
          <p
            className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed"
          >
            {t("hero.emotionalSubheadline")}
          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <a href="#contact" className="btn-gold text-base px-8 py-4 whitespace-nowrap">
              {t("hero.cta.startDefense")}
            </a>
            <a
              href="tel:2125860500"
              onClick={trackPhoneClick}
              className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/30 text-white rounded-md hover:bg-white/10 transition-colors font-medium whitespace-nowrap"
            >
              <Phone className="w-4 h-4" />
              {t("hero.cta.call")}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div
        className="absolute bottom-8 inset-x-0 flex flex-col items-center"
      >
        <span className="text-white/50 text-xs uppercase tracking-widest">{t("hero.scroll")}</span>
        <ChevronDown className="w-5 h-5 text-white/50 mx-auto mt-1 animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
